// extracted by mini-css-extract-plugin
export var root = "generic-page-title-module--root--28PXS";